
















import { Component, Vue } from 'vue-property-decorator';

import Version from '@/components/version.vue';

@Component({
  components: {
    Version,
  },
})
export default class RelatedArticlesItemComponent extends Vue {
}
